export default __webpack_public_path__ + "static/SpotCast-Favicon-08-a38afc7124d55c404c95260ecae8bd92.png";